import PAYOUT_API from 'api/payout/payout/v1'
import PAYOUT_PROFILES_API from 'api/payout/profiles/v1'
import PAYOUTS_API from 'api/payouts/v1'
import REFERRALS_API from 'api/referrals/v1'
import { startSubmit, stopSubmit, SubmissionError } from 'redux-form'
import { call, debounce, put, takeLatest } from 'redux-saga/effects'
import extractErrors from 'utils/extractErrors'
import prepareFilterParams from 'utils/prepareFilterParams'
import { notificationShow } from 'modules/Notifications/actions'

function* fetchPayoutProfiles({ payload }) {
  try {
    yield put({
      type: 'USER/USER_PAYOUT_PROFILES_SET_LOADING',
      payload: { loading: true, loaded: false },
    })

    const { response, error } = yield call(PAYOUT_PROFILES_API.fetchProfiles, {
      params: payload.params,
    })

    if (error) {
      throw error
    }

    const { data, pagination } = response
    yield put({
      type: 'USER/SET_USER_PAYOUT_PROFILES',
      payload: { data, pagination },
    })
  } catch (error) {
    yield put(
      notificationShow({
        type: 'error',
        message: 'common::notifications.data_fetch_failed',
      }),
    )
    console.logXHR(error)
  } finally {
    yield put({
      type: 'USER/USER_PAYOUT_PROFILES_SET_LOADING',
      payload: { loading: false },
    })
  }
}

function* PayoutProfileCreate({
  payload,
  formName,
  profileId,
  meta: { resolve = () => {}, reject = () => {} } = {},
}) {
  try {
    yield put(startSubmit(formName))

    const { error } = yield call(
      profileId ? PAYOUT_PROFILES_API.update : PAYOUT_PROFILES_API.create,
      {
        profileId,
        data: payload,
      },
    )

    if (error) {
      throw error
    }

    yield put(
      notificationShow({
        type: 'success',
        message: 'referral::payout_profiles_new.notifications.success',
        delay: 10000,
      }),
    )

    resolve()
  } catch (error) {
    const { form, fields } = extractErrors(error.errors)

    reject(fields ? new SubmissionError(fields) : error.statusText)

    if (form) {
      yield put(
        notificationShow({
          type: 'error',
          message: form,
          delay: 10000,
        }),
      )
    }

    console.logXHR(error)
  } finally {
    yield put(stopSubmit(formName))
  }
}

function* referralFetchInfo() {
  try {
    yield put({ type: 'REFERRAL/START_LOADING', payload: 'info' })

    const { response, error } = yield call(REFERRALS_API.fetchInfo)

    if (error) {
      throw error
    }

    yield put({ type: 'REFERRAL/SET_INFO', payload: response.data })
  } catch (error) {
    yield put({ type: 'REFERRAL/LOADING_FAILED', payload: 'info' })
    console.logXHR(error)
  }
}

function* referralFetchList({ payload }) {
  try {
    yield put({ type: 'REFERRAL/START_LOADING', payload: 'list' })

    const { response, error } = yield call(REFERRALS_API.fetchAll, {
      params: prepareFilterParams(payload),
    })

    if (error) {
      throw error
    }

    yield put({ type: 'REFERRAL/SET_LIST', payload: response })
  } catch (error) {
    yield put({ type: 'REFERRAL/LOADING_FAILED', payload: 'list' })
    console.logXHR(error)
  }
}

function* referralTypeQuery({ payload }) {
  yield put({ type: 'REFERRAL/SET_QUERY', payload })
}

function* referralPayoutCreate({
  payload,
  formName,
  meta: { resolve = () => {}, reject = () => {} } = {},
}) {
  try {
    yield put(startSubmit(formName))

    const { error } = yield call(PAYOUT_API.requestPayout, payload)

    if (error) {
      throw error
    }

    yield put(
      notificationShow({
        type: 'success',
        message: 'referral::payout_request.notifications.success',
        delay: 10000,
      }),
    )

    resolve()
  } catch (error) {
    const { form, fields } = extractErrors(error.errors)

    reject(fields ? new SubmissionError(fields) : error.statusText)

    if (form) {
      yield put(
        notificationShow({
          type: 'error',
          message: form,
          delay: 10000,
        }),
      )
    }

    console.logXHR(error)
  } finally {
    yield put(stopSubmit(formName))
  }
}

function* referralPayoutsListFetch({ payload }) {
  try {
    yield put({ type: 'REFERRAL/PAYOUTS_LIST_START_LOADING' })

    const { response, error } = yield call(PAYOUTS_API.fetchPayoutsList, {
      params: prepareFilterParams(payload),
    })

    if (error) {
      throw error
    }

    yield put({ type: 'REFERRAL/PAYOUTS_LIST_SET_LIST', payload: response })
  } catch (error) {
    yield put({ type: 'REFERRAL/PAYOUTS_LIST_LOADING_FAILED' })
    console.logXHR(error)
  }
}

export default function* Sagas() {
  yield takeLatest('REFERRAL/FETCH_INFO', referralFetchInfo)
  yield takeLatest('REFERRAL/FETCH_LIST', referralFetchList)
  yield debounce(750, 'REFERRAL/TYPE_QUERY', referralTypeQuery)
  yield takeLatest('REFERRAL/PAYOUT_PROFILE_CREATE', PayoutProfileCreate)
  yield takeLatest('REFERRAL/PAYOUT_PROFILES_FETCH', fetchPayoutProfiles)
  yield takeLatest('REFERRAL/PAYOUT_REQUEST_CREATE', referralPayoutCreate)
  yield takeLatest('REFERRAL/PAYOUTS_LIST_FETCH', referralPayoutsListFetch)
}
